import { useMemo } from "react";

import { useOrderApps, useOrderAssignees } from "@web-app/api";
import useDispatchStore from "@web-app/store/dispatchStore";
import { Order } from "@web-app/types";

import OrderDetailsPanel from "../common/OrdersSidebar/OrderDetailsPanel";

import OrderEditPanelWrapper from "./OrderEditPanelWrapper";

interface OrderDetailsProps {
  order: Order;
}

export default function OrderDetails({ order }: OrderDetailsProps) {
  const { isEditOrder } = useDispatchStore();

  const orders = useMemo(() => [order], [order]);
  const { assigneesMap } = useOrderAssignees(orders);
  const { appsMap } = useOrderApps(orders);

  return (
    <div className="flex w-[560px] bg-white absolute right-0 top-0 overflow-y-scroll h-full">
      {isEditOrder ? (
        <OrderEditPanelWrapper
          order={order}
          onClose={() => {
            useDispatchStore.setState({
              isEditOrder: false,
            });
          }}
        />
      ) : (
        <OrderDetailsPanel
          assigneesMap={assigneesMap}
          appsMap={appsMap}
          order={order}
        />
      )}
    </div>
  );
}
